/**
 * 页面状态
 */
enum PAGE_STATE_CONFIG {
    DEFAULT = 0,
    SUCCESS = 1,
    NODATA = 2,
    FAIL = 3,
    LOADING = 4,
    SERVER_FAIL = 5,
    NETWORK_FAIL = 6,
}

/**
 * 图片上传失败状态
 */
enum IMAGE_ERROR {
    PARAMS_ERROR = 400, // 参数错误
    FORMAT_ERROR = 412, // 图片格式错误
    SERVER_ERROR = 500, // Vis服务错误等
}

/**
 * 学生认证状态
 */
enum STUDENT_AUTH_CONFIG {
    // 未认证
    NOT_AUTH = 0,
    // 认证失败
    FAIL = 1,
    // 机器认证中
    AUTH_ING = 2,
    // 人工审核中
    MAN_AUTHING = 3,
    // 认证成功
    SUCCESS = 4,
}

// 0: "代金券",
// 1: "惊喜券",
// 2: "折扣券",
// 3: "满减券",
// 4: "单品券",
// 5: "会员券",
// 6: "兑换券"
enum COUPON_TYPE {
    PAYMENT = 0,
    SURPRISE = 1,
    DISCOUNT = 2,
    PRICER_REDUCTION = 3,
    SINGLE = 4,
    VIP = 5,
    EXCHANGE = 6
}

/**
 * 支持的聊天模式
 */
enum CHAT_MODE {
    DEFAULT = 0,
    FULLSCREEN_VOICE = 1,
}

/**
 * 输入框的模式
 */
enum INPUT_MODE {
    DEFAULT = 0,
    VOICE = 1,
}

/**
 * 聊天模式
 */
enum TALK_MODE {
    /**
     * 默认模式
     */
    DEFAULT = 0,
    /**
     * 虚拟人
     */
    VIRTUAL = 1,
    /**
     * 直播数字人
     */
    DIGITAL = 2,
}

enum STABILITY_LOG_STATUS {
    SSE_CONNECT_ERROR = 0,
    SSE_CONNECT_TIMEOUT = 100,
    SSE_CHUNK_TIMEOUT = 101,
    SSE_CHUNK_ERROR = 102,
    SSE_SUCCESS = 200,
}

// tts个性语音包下载状态映射
enum TTS_STATE_CONFIG {
    // 已创建
    CREATE = 1,
    // 排队中
    QUEUING = 2,
    // 训练中
    TRAINING = 3,
    // 成功
    SUCCESS = 4,
    // 失败
    FAIL = 5,
    // 不可播放
    NOT_PLAYABLE = 6,
}

enum MATRI_STYLE {
    // 青少年模式
    Teenager = '2',
    Default = '0',
}

export {
    CHAT_MODE,
    COUPON_TYPE,
    IMAGE_ERROR,
    INPUT_MODE,
    MATRI_STYLE,
    PAGE_STATE_CONFIG,
    STABILITY_LOG_STATUS,
    STUDENT_AUTH_CONFIG,
    TALK_MODE,
    TTS_STATE_CONFIG,
};
